import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=99430542"
import script from "./EmployeeCard.vue?vue&type=script&lang=ts"
export * from "./EmployeeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99430542')) {
      api.createRecord('99430542', component.options)
    } else {
      api.reload('99430542', component.options)
    }
    module.hot.accept("./EmployeeCard.vue?vue&type=template&id=99430542", function () {
      api.rerender('99430542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeCard.vue"
export default component.exports